import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import Map from './components/map';
import Feed from './view/feed';
import New from './view/new';
import Footer from './components/footer';
import Login from './components/login';
import Register from './components/register';
import Logout from './components/logout';
import User from './components/user';
import Settings from './components/settings';
import Dashboard from './components/dashboard';
import Errors from './components/errors';

import './App.css';

export default class App extends Component {
	constructor(props) {
    super(props);
		this.getMessages = this.getMessages.bind(this);
		this.locationChange = this.locationChange.bind(this);
		this.statusChange = this.statusChange.bind(this);
		this.settingsChange = this.settingsChange.bind(this);
		this.refresh = this.refresh.bind(this);
		this.state = {
			authorized: false,
			data: false,
			settings : {
				autoload: false,
		    autorefresh: false
			}
    }
		this.location = {
			latitude: 0,
	    longitude: 0
		}
		console.log('App init', this.state);
  }
	componentWillMount() {
		console.log('Checking if user is signed in');
		if(sessionStorage.getItem("authorized")) {

			this.setState({
				authorized: true,
				user: {
					id: sessionStorage.getItem("id"),
					hash: sessionStorage.getItem("hash"),
					name: sessionStorage.getItem("name")
				}
			});

			let autoload = sessionStorage.getItem("autoload") === "true" ? true : false;
			let autorefresh = sessionStorage.getItem("autorefresh") === "true" ? true : false;
			this.setState({ settings : { autoload: autoload, autorefresh: autorefresh } });

			this.location.latitude = sessionStorage.getItem("latitude");
			this.location.longitude = sessionStorage.getItem("longitude");
			console.log('User is logged in.');

		} else {
			this.setState({ authorized: false, user: false });
			console.log('User is not logged in.');
		}
	}
	componentDidMount() {
		console.log('Should we ask for the messages?', this.state);
		if(this.state.settings.autoload === true) {
			console.log('Yes, we should.');
			this.getMessages();
		} else {
			console.log('Nope.');
		}
	}
	locationChange(data) {
		console.log('Location changed. Could\'ve been be user or device. ', data);
		sessionStorage.setItem("latitude", data.latitude);
		sessionStorage.setItem("longitude", data.longitude);
		this.location = data;
	}
	statusChange(data) {
		console.log('User status changed. User logged in or logged off. ', data);

		if(data.hash) {

			console.log('Logging in', data);
			sessionStorage.setItem("authorized", true);
			sessionStorage.setItem("id", data.id);
			sessionStorage.setItem("hash", data.hash);
			sessionStorage.setItem("name", data.name);

			this.setState({
				authorized: true,
				user: data
			});

		} else {
			console.log('Logging out');
			sessionStorage.removeItem("authorized");
			sessionStorage.removeItem("id");
			sessionStorage.removeItem("hash");
			sessionStorage.removeItem("name");

			this.setState({
				authorized: false,
				user: false
			});
		}
	}

	settingsChange(data) {
		console.log('User settings changed. ', data);
		sessionStorage.setItem("autoload", data.autoload);
		sessionStorage.setItem("autorefresh", data.autorefresh);
		this.setState({ settings: data });
	}

	refresh() {
		this.getMessages();
	}
	getMessages() {
		console.log('Asking for posts');
		fetch('https://atround.com/services/posts.php', {
			method: "POST",
			headers: {
				"Accept": "application/json",
			},
			body: JSON.stringify(this.location)
		})
		.then(res => res.json())
		.then(
			(result) => {
				let data = result.data;
				if(!data) data = false;
				else {
					console.log('Postman arrived', result);

					data.map((post) => {

						if(post.post) {

							let rows = post.post.split("\n");
							rows = rows.map((row, i) => {

								if(row.slice(0, 3) === "<p>") {

									return <p key={ i }>{row.replace(/<p>|<\/p>/gi, "")}</p>

								} else if(row.slice(0, 10) === "<img src=\"") {
									// !!!!!!!!!!!!!!!!!!!!!!!!
									return <img key={ i } src={row.replace(/<img src="|" \/>|"\/>/gi, "")} alt="User" />

								} else if(row.slice(0, 13) === "<iframe src=\"") {
									// !!!!!!!!!!!!!!!!!!!!!!!!
									return <iframe key={ i } src={row.replace(/<iframe src="|" \/>|" \/>/gi, "")} title="External content" />

								} else {
									return <p key={ i }>{row}</p>;
								}
							});

							post.post = rows;
						}
						return post;
					});
				}

				this.setState({
					data: data
				}, () => console.log('Postman delivered.', this.state));
			},
			(error) => {
				this.setState({ error: 'NO-CONN' });
			}
		);
	}

	render() {
		let slug = 'index';
		const path = this.props.location.pathname;

		if(path === '/add') slug = 'add';
		else if(path === '/add/content') slug = 'add-content';
		else if(path === '/add/profile') slug = 'add-profile';
		else if(path === '/add/unpublishtime') slug = 'add-upt';
		else if(path === '/add/publish') slug = 'add-publish';
		else if(path === '/dashboard') slug = 'dashboard';
		else if(path === '/logout') slug = 'logout';

		console.log('APP render ', slug, path, this.state);

	  return (
			<div id="atround" className={ slug }>
				<header id="header">
					<div id="title"><Link to="/">atRound</Link></div>
					<User data={ this.state }/>
				</header>
				<Errors error={ this.state.error } />
				<Map onLocationChange = { this.locationChange }/>
				<Switch>
      		<Route path="/add" render={() => <New data={ this.state } path={ this.props.location } location={ this.location } onStatusChange={ this.statusChange } /> }/>
					<Route path="/register" component={ Register }/>
					<Route path="/login" render={() => <Login data={ this.state } onStatusChange={ this.statusChange } />}/>
					<Route path="/dashboard" component={ Dashboard }/>
					<Route path="/settings" render={() => <Settings settings={ this.state.settings } onSetChange={ this.settingsChange } onStatusChange={ this.statusChange } />}/>
					<Route path="/logout" render={() => <Logout data={ this.state } onStatusChange={ this.statusChange } />}/>
					<Route render={ () => <Feed posts={ this.state.data } onRefresh={ this.refresh }/> }/>
				</Switch>
				<Footer/>
			</div>
	  )
	}
}



// WEBPACK FOOTER //
// ./src/App.js